<div class=" custom-container mt-2">
  <ng-container *ngIf="!consultant">
    <div class="row  align-items-center">

      <div class="col-auto head-project">
        اسم المشروع
      </div>
      <div class="col-auto mx-5">
        <span class="head-reply">
          {{project?.name}}
        </span>
      </div>
    </div>

    <div class="row  mt-3 align-items-center">
      <div class="col-auto head-project">
        رقم النموذج/التاريخ
      </div>

      <div class="col-auto mx-5">
        <span class="head-reply">
          رقم ({{No}}) , {{date|date}}
        </span>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="consultant">
    <div class="row justify-content-center align-items-center">
      <div class="col-auto ">
        <span class="head-reply">
          {{project?.name}}
        </span>
      </div>
    </div>

    <div class="row justify-content-center mt-3 align-items-center">
      <div class="col-auto ">
        <span class="head-reply">
          رقم ({{No}}) , {{date|date}}
        </span>
      </div>
    </div>
  </ng-container>
</div>
<div class=" custom2-container">
  <div class="row d-flex justify-content-center">
    <!-- First column -->
    <div class="col-md-3 municipality">
      <img *ngIf="projectHeader?.contractor?.logo !== ''" [src]="domain + projectHeader?.consultant?.logo"
        class="logo-full-width" alt="consultant Logo" />
      <div class="mt-4">
        <p class="logo-name">مكتب استشاري: <span class="logo-answer mx-2">{{projectHeader?.consultant?.name ||
            '-'}}</span>
        </p>
        <p class="logo-name">الهاتف: <span class="logo-answer mx-2">{{projectHeader?.consultant?.phoneNumber || '-'
            }}</span> </p>
      </div>
    </div>

    <!-- Divider -->
    <div class="col-md-1 d-flex justify-content-center align-items-center">
      <div class="divider"></div>
    </div>

    <!-- Second column -->
    <div class="col-md-3 municipality">
      <img src="../../../../../../../../assets/images/Group-logo.svg" />
      <div class="mt-3">
        <p class="logo-name">المالك: <span class="logo-answer mx-2">{{projectHeader?.ownerName || '-'}}</span>
        </p>
      </div>

    </div>

    <!-- Divider -->
    <div class="col-md-1 d-flex justify-content-center align-items-center">
      <div class="divider"></div>
    </div>

    <!-- Third column -->
    <div class="col-md-3 municipality">

      <img *ngIf="projectHeader?.contractor?.logo !== ''" [src]="domain + projectHeader?.contractor?.logo"
        class="logo-full-width" alt="Contractor Logo" />

      <div class="mt-3">
        <p class="logo-name">شركة المقاولات: <span class="logo-answer mx-2">{{projectHeader?.contractor?.name ||
            '-'}}</span>
        </p>
        <p class="logo-name">الهاتف: <span class="logo-answer mx-2">{{projectHeader?.consultant?.phoneNumber ||
            '-'}}</span> </p>
      </div>
    </div>

  </div>
</div>